import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { svgColorStyle, svgDisplayStyle, svgKeys, svgPointerStyle, svgSizeStyle } from './style';
import { baseHighlightStyle } from '../tokens/highlight'; // Component to be used 'as' an SVG element
// e.g. <Icon as={LocationIcon} size={24} color={'#000'} />

var Icon = styled.span.withConfig(withOmitProps(svgKeys))(_templateObject(), baseHighlightStyle, svgDisplayStyle, svgSizeStyle, svgColorStyle, svgPointerStyle);
export default Icon;